import React,{useState,useEffect} from "react";
import { useLottie } from "lottie-react";
import newHintAnimation from "./../Lotties/newHint_vStage.json";
// // import Mouse from "../images/Mouse_Tutorial.gif"
// import Touch from "../images/Touch_Tutorial.gif"
import {isMobile} from 'react-device-detect';
// import ViewItem from "./ViewItem";


export default function HoveredAnimationTutorial(props){

    const options = {
        animationData: newHintAnimation,
        loop: true
    };

    const { View } = useLottie(options);


    const [enabled, setEnabled] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setEnabled(false)
          }, "7000")
    }, [])
  
    
    return(

        
        <div >
            {enabled ? 
                (isMobile) ? <div className="hovered-item">{View}</div>
                : 
                <div className="hovered-item">{View}</div>                           
            :
                null
            }
        </div>
    )
}